module.exports = __webpack_public_path__ + "c_static/img/B-2京东搜索截图.4a58fb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/B-2京东搜索截图.jpg
// module id = dqUA
// module chunks = 33